import { memo } from 'react';

import { connect } from 'react-redux';
import { compose, withPropsOnChange } from 'recompact';

import { setLocationAction } from 'src/app/state/actions/index';
import { fetchOrderHistory } from 'src/app/state/actions/order';
import { isLoggedIn } from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';
import { MAP_CAPSULE_FACILITY_ID_TO_LOCATION } from 'src/consts';

/*
 * This component sets a logged in user's location so that localized content ( Capsule Facility address, etc)
 * can be set
 *
 * The component checks for Capsule facility in the following order:
 *
 * check address of last order, if facility found set Capsule location
 * check account default address, if facility found set Capsule location
 * if no address found, do not alter location
 */

function makeMapStateToProps() {
  return (state: RootState) => {
    const facilityId = state.facility.id;

    return {
      isLoggedIn: isLoggedIn(state),
      facilityId,
    };
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchLoadCurrentUserOrderHistory: () => dispatch(fetchOrderHistory()),
  dispatchSetLocationAction: location => dispatch(setLocationAction(location)),
});

export default compose(
  connect(makeMapStateToProps, mapDispatchToProps),
  withPropsOnChange(['isLoggedIn', 'facilityId'], async ({ isLoggedIn, dispatchSetLocationAction, facilityId }) => {
    if (isLoggedIn && facilityId) {
      dispatchSetLocationAction(MAP_CAPSULE_FACILITY_ID_TO_LOCATION[facilityId]);
    }
  }),
  memo
)(() => null);
